<nz-row nzGutter="8">
    <nz-col nzSpan="24">
      <nz-row nzGutter="8" style="padding-right:350px;">
        <nz-col nzSpan="8" style="text-align: left;"><nz-form-label nzFor="filterDate">Date</nz-form-label></nz-col>
        <nz-col nzSpan="16">
          <nz-form-item>
            <nz-range-picker [(ngModel)]="filterDate" nzDropdownClassName="customCalendar" (ngModelChange)="onDateChange($event)">
            </nz-range-picker>
          </nz-form-item>
        </nz-col>
        
      </nz-row>
      <nz-row nzGutter="8" style="padding-right:350px;">
        <nz-col nzSpan="8" style="text-align: left;"><nz-form-label nzFor="filterDate">Document #</nz-form-label></nz-col>
        <nz-col nzSpan="16">
          <nz-form-item *ngIf="this.docType === 'PR'">
            <app-pr-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-pr-select>
            <span class="text-center">
              <span nz-icon nzType="swap-right" nzTheme="outline"></span>
            </span>
            <app-pr-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-pr-select>
          </nz-form-item>
          
          <nz-form-item *ngIf="this.docType === 'PO'">
            <app-po-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-po-select>
            <span class="text-center">
              <span nz-icon nzType="swap-right" nzTheme="outline"></span>
            </span>
            <app-po-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-po-select>
          </nz-form-item>

          <nz-form-item *ngIf="this.docType === 'GRN'">
            <app-grn-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-grn-select>
            <span class="text-center">
              <span nz-icon nzType="swap-right" nzTheme="outline"></span>
            </span>
            <app-grn-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-grn-select>
          </nz-form-item>

          <nz-form-item *ngIf="this.docType === 'CP'">
            <app-cp-select [(ngModel)]="this.docFrom" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-cp-select>
            <span class="text-center">
              <span nz-icon nzType="swap-right" nzTheme="outline"></span>
            </span>
            <app-cp-select [(ngModel)]="this.docTo" class="report-control" (ngModelChange)="onDocChange()"
              valueField="docCode" [outstandingOnly]="true">
            </app-cp-select>
          </nz-form-item>

        </nz-col>
      </nz-row>
    </nz-col>
  </nz-row>
  
  
  <nz-table #t [nzData]="srv.outstandingDocs" [nzFrontPagination]="false" [nzShowPagination]="false" nzBordered="true"
    nzSize="small" [nzScroll]="{ x: '800px', y: '400px' }">
    <thead>
      <tr>
        <th *ngIf="!disabled" nzWidth="100px" [nzAlign]="'center'">
          Transfer
        </th>
        <ng-container *ngFor="let col of columns; let index = index; let last = last">
          <th [nzWidth]="$any(col)?.width" nz-resizable nzPreview (nzResizeEnd)="col.width = $event.width + 'px'"
            [nzAlign]="$any(col).align ?? 'left'">
            <nz-resize-handle *ngIf="!last" nzDirection="right">
              <i></i>
            </nz-resize-handle>
            {{ col.title }}
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of t.data">
        <td *ngIf="!disabled">
          <nz-switch [ngModel]="item.isTransfer" [nzControl]="true" (click)="toggleTransfer(item)">
          </nz-switch>
        </td>
        <td>
          {{ item.docDate | customDate}}
        </td>
        <td>
          {{ item.docCode }}
        </td>
        <td>
          {{ item.referenceNo }}
        </td>
        <td>
          {{ item.supplierName }}
        </td>
        <td class="text-right">
          {{ item.netTotalAmountLocal | price }}
        </td>
      </tr>
    </tbody>
  </nz-table>
